export default __webpack_public_path__ + "static/media/fac_whitebg.1d9228cd.png";